export const primaryNaics = {
  code: "541511",
  description: "Custom Computer Programming Services",
};

export const additionalNaics = [
  {
    code: "541512",
    description: "Computer Systems Design Services",
  },
  {
    code: "541513",
    description: "Computer Facilities Management Services",
  },
  {
    code: "541519",
    description: "Other Computer Related Services",
  },
  {
    code: "518210",
    description:
      "Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services",
  },
];